export default "__VITE_ASSET__D5yPTM6X__"